import { Directive, HostListener } from '@angular/core';
import { BaseDirective } from './base.directive';

@Directive({
  selector: '[appMaxFour]',
  standalone: true
})
export class MaxFourDirective extends BaseDirective {

  constructor() { super(); }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.teclaPermitidaPresionada(event)) return;
    this.filterInput(event);
  }

  filterInput(event: KeyboardEvent) {
    if ((event.target as HTMLInputElement).value.length >= 4) {
      event.preventDefault();
    }
  }
}
